// src/components/ProtectedRoute.jsx - UPDATED with Professor + HOD support
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getDashboardPathForUser } from '../constants/roleRoutes';

const ProtectedRoute = ({ children, allowedRoles, requireSubrole, excludeSubrole }) => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div className="loading-container" style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div className="spinner-large"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check role-based access
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Redirect to appropriate dashboard based on user role and subrole
    return <Navigate to={getDashboardPathForUser(user)} replace />;
  }

  // Special handling for Professor + HOD role
  const userSubrole = user.profile?.faculty_subrole;
  const isProfessorHOD = userSubrole === 'PROFESSOR_HOD';

  // Professor + HOD can access both Faculty and HOD dashboards
  if (isProfessorHOD) {
    // Allow access to both faculty and HOD routes
    if (requireSubrole === 'HEAD_OF_DEPARTMENT' || excludeSubrole === 'HEAD_OF_DEPARTMENT') {
      // Professor + HOD can access both, so don't restrict
      return children;
    }
  }

  // Check subrole requirement (e.g., HEAD_OF_DEPARTMENT)
  if (requireSubrole) {
    // Allow HEAD_OF_DEPARTMENT for both HOD and Professor + HOD
    if (requireSubrole === 'HEAD_OF_DEPARTMENT') {
      if (userSubrole !== 'HEAD_OF_DEPARTMENT' && userSubrole !== 'PROFESSOR_HOD') {
        return <Navigate to={getDashboardPathForUser(user)} replace />;
      }
    } else if (userSubrole !== requireSubrole) {
      return <Navigate to={getDashboardPathForUser(user)} replace />;
    }
  }

  // Check subrole exclusion (e.g., exclude HOD from regular faculty dashboard)
  if (excludeSubrole) {
    // Don't exclude Professor + HOD from faculty dashboard (they can access both)
    if (userSubrole === excludeSubrole && !isProfessorHOD) {
      return <Navigate to={getDashboardPathForUser(user)} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;

